import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {KnockoutFieldModel} from "../../../../core/components/knockout-field/knockout-field.model";
import {AuditHistoryService} from "../../../../core/services/audit-history/audit-history.service";
import {AuditHistoryHeaderModel} from "../../../../core/services/audit-history/audit-history-header.model";
import {$translate, $translateKey} from "../../../../core/services/internationalization/localize.service";

@Component({
  selector: 'sb-audit-history-header',
  templateUrl: './audit-history-header.component.html',
  styleUrls: ['./audit-history-header.component.scss']
})
export class AuditHistoryHeaderComponent implements OnInit, OnChanges {

  @Input()
  header: AuditHistoryHeaderModel;

  koRelatedRecord: KnockoutFieldModel = null;

  recordLabel = $translateKey("audithistory.label.record");

  relatedIdLabel = $translateKey("audithistory.label.related-id");
  tableLabel = $translateKey("audithistory.label.table");

  constructor(private auditHistoryService: AuditHistoryService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.header && this.header && !this.koRelatedRecord) {
      this.koRelatedRecord =
        this.auditHistoryService.generateKnockoutReferenceFieldDefinition(this.header.RelatedRecord,
          $translate("audithistory.label.related-record")`Related record`,
          this.header?.RelatedTable?.value as string,
          this.header?.RelatedID?.value as string);
    }
  }
}
